export const SIDE_PANEL_COLLAPSED_HEIGHT_PX = 106;
export const SIDE_PANEL_COLLAPSED_BUFFER_PX = 28;
export const OPEN_TOP_GAP_PX = 40;

export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_id",
  "utm_term",
  "utm_content",
] as const;

export type UtmKey = (typeof UTM_KEYS)[number];
